module.exports = __webpack_public_path__ + "img/service-event-ticket.e5f49af7.png";